export class SnapshotLocation {
    'snapshotId';
    'region';
    'snapshotType';
    'vaultName';
    'vaultResourceGroup';
    'vaultType';
    'diskId';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "snapshotId",
            "baseName": "snapshotId",
            "type": "string",
            "format": ""
        },
        {
            "name": "region",
            "baseName": "region",
            "type": "string",
            "format": ""
        },
        {
            "name": "snapshotType",
            "baseName": "snapshotType",
            "type": "SnapshotLocationSnapshotTypeEnum",
            "format": ""
        },
        {
            "name": "vaultName",
            "baseName": "vaultName",
            "type": "string",
            "format": ""
        },
        {
            "name": "vaultResourceGroup",
            "baseName": "vaultResourceGroup",
            "type": "string",
            "format": ""
        },
        {
            "name": "vaultType",
            "baseName": "vaultType",
            "type": "AzureVaultType",
            "format": ""
        },
        {
            "name": "diskId",
            "baseName": "diskId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SnapshotLocation.attributeTypeMap;
    }
    constructor() {
    }
}
export var SnapshotLocationSnapshotTypeEnum;
(function (SnapshotLocationSnapshotTypeEnum) {
    SnapshotLocationSnapshotTypeEnum["Compute"] = "compute";
    SnapshotLocationSnapshotTypeEnum["RecoveryServices"] = "recovery_services";
})(SnapshotLocationSnapshotTypeEnum || (SnapshotLocationSnapshotTypeEnum = {}));
